import {
	isToday,
	isYesterday,
	isTomorrow,
	isThisWeek,
	isSameWeek,
	addWeeks,
	isThisMonth,
	isSameMonth,
	addMonths,
	isBefore,
	intlFormat,
} from "date-fns";

export function toDate(_date: number | string | Date): Date | null {
	switch (typeof _date) {
		case "number":
			return new Date(_date);
		case "string":
			return new Date(_date);
		case "object":
			if (_date.constructor === Date) _date;
			break;
	}
	return null;
}

export function toEpochTime(_date: number | string | Date): number {
	switch (typeof _date) {
		case "number":
			return _date;
		case "string":
			return +new Date(_date);
		case "object":
			if (_date.constructor === Date) return _date.getTime();
			break;
	}
	return +new Date();
}

export function prettyDate(date: Date) {
	if (isToday(date)) {
		return "Today";
	} else if (isYesterday(date)) {
		return "Yesterday";
	} else if (isTomorrow(date)) {
		return "Tomorrow";
	} else {
		return date.toLocaleDateString();
		//datestr = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
	}
}

export function relativeDate(_date: number | string | Date) {
	const date = toDate(_date);
	const now = new Date();

	if (date === null) {
		return "";
	} else if (isToday(date)) {
		return "Today";
	} else if (isYesterday(date)) {
		return "Yesterday";
	} else if (isTomorrow(date)) {
		return "Tomorrow";
	} else if (isThisWeek(date)) {
		return "This Week";
	} else if (isSameWeek(date, addWeeks(now, 1))) {
		return "Next Week";
	} else if (isSameWeek(date, addWeeks(now, -1))) {
		return "Last Week";
	} else if (isThisMonth(date)) {
		return "This Month";
	} else if (isSameMonth(date, addMonths(now, 1))) {
		return "Next Month";
	} else if (isSameMonth(date, addMonths(now, -1))) {
		return "Last Month";
	} else if (isBefore(date, now)) {
		return "Before Last Month";
	} else {
		return "After Next Month";
	}
}

export function timeAgo(_time: number | string | Date) {
	const time_formats: [number, string, number | string][] = [
		[60, "seconds", 1],
		[120, "1 minute ago", "1 minute from now"],
		[3600, "minutes", 60],
		[7200, "1 hour ago", "1 hour from now"],
		[86400, "hours", 3600],
		[172800, "Yesterday", "Tomorrow"],
		[604800, "days", 86400],
		[1209600, "Last week", "Next week"],
		[2419200, "weeks", 604800],
		[4838400, "Last month", "Next month"],
		[29030400, "months", 2419200],
		[58060800, "Last year", "Next year"],
		[2903040000, "years", 29030400],
		[5806080000, "Last century", "Next century"],
		[58060800000, "centuries", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
	];

	const time = toEpochTime(_time);
	let seconds = (+new Date() - time) / 1000;
	let token = "ago";
	let list_choice = 1;

	if (Math.abs(seconds) < 1) {
		return "Just now";
	}
	if (seconds < 0) {
		seconds = Math.abs(seconds);
		token = "from now";
		list_choice = 2;
	}
	let i = 0,
		format: [number, string, number | string];
	while ((format = time_formats[i++]))
		if (seconds < format[0]) {
			if (typeof format[2] == "string") return format[list_choice].toString();
			else return Math.floor(seconds / format[2]) + " " + format[1] + " " + token;
		}
	return time.toString();
}

export function isoToLocale(iso: string): string {
	const s =
		new Date(iso ?? "").toLocaleDateString() +
		" " +
		new Date(iso ?? "").toLocaleTimeString([], { timeStyle: "short" });
	return s;
}

export function formatSeconds(seconds: number): string {
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(seconds / (60 * 60));
	const days = Math.floor(seconds / (60 * 60 * 24));

	let f = "";
	if (days > 0) f = `${days}d ${hours % 24}h ${minutes % 60}m`;
	else if (hours > 0) f = `${hours % 24}h ${minutes % 60}m`;
	else f = `${minutes % 60}m ${seconds % 60}s`;

	return f;
}

export function formatMinutes(minutes: number): string {
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(minutes / (60 * 24));

	let f = "";
	if (days > 0) f = `${days}d ${hours % 24}h ${minutes % 60}m`;
	else f = `${hours % 24}h ${minutes % 60}m`;

	return f;
}

export function shortMonth(monthOrdinal: number, locale: string = "default"): string {
	const date = new Date("1/1/2000");
	date.setMonth(monthOrdinal - 1); // Month is 0-indexed

	return date.toLocaleString(locale, { month: "short" });
}

export function longMonth(monthOrdinal: number, locale: string = "default"): string {
	const date = new Date("1/1/2000");
	date.setMonth(monthOrdinal - 1); // Month is 0-indexed

	return date.toLocaleString(locale, { month: "long" });
}

export const localeDate = (date: Date | string) => new Date(date).toLocaleDateString();

export const localeShortDateTime = (date: Date | string) => {
	const datestr = `${new Date(date).toLocaleDateString("en-US", {
		month: "numeric",
		day: "2-digit",
		year: "2-digit",
	})}`;
	const timestr = `${new Date(date).toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "numeric",
		hour12: true,
	})}`;
	return datestr + " " + timestr;
};
